import { accommodationsCurrencySymbolByCountry, currencySymbolByPointOfSale } from "./pointOfSaleToCurrency.js";
export const getCurrencySymbolByPointOfSale = (pointOfSale) => {
    return currencySymbolByPointOfSale[pointOfSale];
};
export const getAccommodationsCurrencySymbolByCountry = (countryCode) => {
    return accommodationsCurrencySymbolByCountry[countryCode];
};
